module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._l((_vm.list), function(row, i) {
    return (i < 1) ? _c('div', {
      staticClass: "row1"
    }, [_c('img', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsList',
          query: {
            cate_id: row.id
          }
        }),
        expression: "{name:'NewsList',query:{cate_id:row.id}}"
      }],
      attrs: {
        "src": row.pic_url
      }
    })]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "row3"
  }, _vm._l((_vm.list), function(row, i) {
    return (i >= 1 && i < 6) ? _c('img', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsList',
          query: {
            cate_id: row.id
          }
        }),
        expression: "{name:'NewsList',query:{cate_id:row.id}}"
      }],
      attrs: {
        "src": row.pic_url
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _vm._l((_vm.list), function(row, i) {
    return (i == 6) ? _c('div', {
      staticClass: "row1",
      staticStyle: {
        "margin": "0px 30px"
      }
    }, [_c('img', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsList',
          query: {
            cate_id: row.id
          }
        }),
        expression: "{name:'NewsList',query:{cate_id:row.id}}"
      }],
      attrs: {
        "src": row.pic_url
      }
    })]) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4397f17c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Jigoushezhi.vue
// module id = 1430
// module chunks = 0